export default __webpack_public_path__ + "static/media/electricity.ea7a2955.svg";